import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { MenuItem } from "@mui/material";

import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import TabelaProcedimentosAgendamento from "../../Components/TabelaProcedimentosAgendamento";
import SelectSituacao from "../../Components/SelectSituacao";
import Loading from "../../../../components/Loading";
import SelectFormaPagamento from "../../Components/SelectFormaPagamento";
import Header from "../../../../components/Header";
import ModalPreviewPrescricao from "../../Components/ModalPreviewPrescricao";
import PrescricoesAgendamento from "../../Components/PrescricoesAgendamento";
import useArquivosPrescricao from "../../data/hooks/useArquivosPrescricao";
import usePreviewPrescricao from "../../data/hooks/usePreviewPrescricao";

import AutoCompleteClientes from "../../../../componentsv2/AutoCompleteClientes";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import Container from "../../../../componentsv2/Container";

import { Context } from "../../../../Context/PermissoesContext";

import ModalProcedimento from "../ModalProcedimento";
import ObservacoesClinicas from "../../Components/ObservacoesClinicas";

import { api } from "../../../../services/Api";
import {
  OPCOES_LOCAL_ATENDIMENTO,
  OPCOES_MEDICACAO_ORIGEM,
  OPCOES_PAGAMENTO_STATUS,
} from "../../constants/agendamentoOptions";
import { abrirNoMaps, temEnderecoMinimo } from "../../utils/abrirNoMaps";
import {
  calcularSubtotal,
  formatarTotalExibicao,
  validarDesconto,
} from "../../utils/descontoAgendamento";
import {
  baixarBlob,
  baixarBlobUrl,
  buscarBlobPrescricao,
} from "../../utils/prescricaoArquivos";
import Box from "../../../../componentsv2/Box";
import BotaoPdfAgendamento from "../../Components/BotaoPdfAgendamento";
import useObterPayloadPdfOrcamento from "../../data/hooks/useObterPayloadPdfOrcamento";

const cpfSomenteDigitos = (cpf) => String(cpf ?? "").replace(/[^0-9]/g, "");

async function enviarContasAReceberSeNecessario(dados) {
  const { data } = await api.get(
    `/v2/contasaReceber/contasAReceberOrigemId/${dados.origemId}`
  );

  if (data?.id) {
    await api.put(`/v2/contasaReceber/editarContasAReceber/${data.id}`, {
      origem: dados.origem,
      origemId: dados.origemId,
      cpfCliente: dados.cpfCliente,
      codigoPedido: dados.codigoPedido,
      valor: dados.valor,
    });
    return;
  }

  await api.post(`/v2/contasaReceber/adicionaContasAReceber`, dados);
}

export default function EditarAgendamento() {
  const [openModalForm, setOpenModalForm] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState([]);
  // [{ procedimentoId, quantidade, precoExame }]
  const [itensIniciais, setItensIniciais] = useState([]);
  const [procedimentosVinculados, setProcedimentosVinculados] = useState([]);
  // [{ procedimentoId, quantidade }] para inicializar a TabelaProcedimentos

  const [situacao, setSituacao] = useState("");
  const [cliente, setCliente] = useState(null);
  const [endereco, setEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [complemento, setComplemento] = useState("");
  const [observacao, setObservacao] = useState("");
  const [desconto, setDesconto] = useState(0);
  const [descontoDebounced, setDescontoDebounced] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [localAtendimento, setLocalAtendimento] = useState("");
  const [medicacaoOrigem, setMedicacaoOrigem] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState("");
  const [nomeCliente, setNomeCliente] = useState("");
  const [cpfCliente, setCpfCliente] = useState("");
  const idAgendamento = useRef("");
  const inputPrescricoesRef = useRef(null);
  const [dataAgendamento, setDataAgendamento] = useState(null);
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [enfermeiroId, setEnfermeiroId] = useState("");
  const [numeroEndereco, setNumeroEndereco] = useState("");
  const [observacaoCliente, setObservacaoCliente] = useState("");

  const [atualizaTabelaProcedimentos, setAtualizaTabelaProcedimentos] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const {
    arquivosPrescricao,
    handleSelecionarArquivosPrescricao,
    handleRemoverArquivoPrescricao,
  } = useArquivosPrescricao();
  const [prescricoes, setPrescricoes] = useState([]);
  const [loadingPrescricoes, setLoadingPrescricoes] = useState(false);
  const { checarPermissao } = useContext(Context);
  const atualizarTabelaProcedimentos = () => {
    setAtualizaTabelaProcedimentos(!atualizaTabelaProcedimentos);
  };

  const { enqueueSnackbar } = useSnackbar();
  const previewPrescricao = usePreviewPrescricao();

  const carregarPrescricoes = useCallback(
    async (agendamentoId) => {
      if (!agendamentoId) return;

      try {
        setLoadingPrescricoes(true);
        const {
          data: { data },
        } = await api.get(`/v2/agendaCare/agendamento/${agendamentoId}/prescricoes`);
        setPrescricoes(Array.isArray(data) ? data : []);
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.messages || "Não foi possível carregar as prescrições.", {
          variant: "warning",
        });
      } finally {
        setLoadingPrescricoes(false);
      }
    },
    [enqueueSnackbar]
  );

  const handleDownloadPrescricao = async (prescricao) => {
    if (!location.state?.row?.id || !prescricao?.id) return;

    try {
      const blob = await buscarBlobPrescricao(location.state.row.id, prescricao);
      baixarBlob(blob, prescricao.nomeOriginal);
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível baixar a prescrição.", {
        variant: "error",
      });
    }
  };

  const handleVisualizarPrescricao = async (prescricao) => {
    if (!location.state?.row?.id || !prescricao?.id) return;

    try {
      await previewPrescricao.abrirPreviewComBlob(prescricao, () =>
        buscarBlobPrescricao(location.state.row.id, prescricao)
      );
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível visualizar a prescrição.", {
        variant: "error",
      });
    }
  };

  const handleDownloadPreview = () => {
    if (!previewPrescricao.blobUrl || !previewPrescricao.arquivoPreview) return;

    baixarBlobUrl(
      previewPrescricao.blobUrl,
      previewPrescricao.arquivoPreview.nomeOriginal
    );
  };

  const handleExcluirPrescricao = async (prescricaoId) => {
    if (!location.state?.row?.id || !prescricaoId) return;

    try {
      await api.delete(
        `/v2/agendaCare/agendamento/${location.state.row.id}/prescricoes/${prescricaoId}`
      );
      await carregarPrescricoes(location.state.row.id);
      enqueueSnackbar("Prescrição removida com sucesso.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.messages || "Não foi possível remover a prescrição.", {
        variant: "error",
      });
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (salvando) return;

    try {
      const possuiValor = (value) => Boolean(String(value ?? "").trim());

      const camposObrigatorios = [
        { label: "Cliente", value: cliente?.id },
        { label: "Situação", value: situacao },
        { label: "Endereço", value: endereco },
        { label: "CEP", value: cep },
        { label: "Bairro", value: bairro },
        { label: "Cidade", value: cidade },
        { label: "Local", value: localAtendimento },
        { label: "Medicação", value: medicacaoOrigem },
        { label: "Pagamento", value: pagamentoStatus },
      ];
      const campoFaltante = camposObrigatorios.find(
        ({ value }) => !possuiValor(value)
      );
      if (campoFaltante) {
        enqueueSnackbar(`Preencha o campo obrigatório: ${campoFaltante.label}.`, {
          variant: "warning",
        });
        return;
      }
      if (procedimentoSelecionado.length === 0) {
        enqueueSnackbar("Selecione ao menos um procedimento.", {
          variant: "warning",
        });
        return;
      }

      const subtotal = calcularSubtotal(procedimentoSelecionado);
      const validacaoDesconto = validarDesconto(desconto, subtotal);
      if (!validacaoDesconto.valido) {
        enqueueSnackbar(validacaoDesconto.mensagem, { variant: "warning" });
        return;
      }

      setSalvando(true);

      const procedimentos = procedimentoSelecionado.map(({ procedimentoId, quantidade }) => ({
        procedimentoId,
        quantidade,
      }));

      const dados = {
        procedimentos,
        complemento,
        observacoes: observacao,
        situacao,
        cep,
        cidade,
        bairro,
        estado,
        endereco,
        clienteId: cliente.id,
        desconto: validacaoDesconto.desconto,
        formaPagamento,
        localAtendimento,
        medicacaoOrigem,
        pagamentoStatus,
      };

      if (situacao === "Realizado") {
        try {
          await enviarContasAReceberSeNecessario({
            origem: "AGENDA CARE",
            origemId: idAgendamento.current || location.state.row.id,
            cpfCliente: cpfSomenteDigitos(cliente?.cpf ?? cpfCliente),
            nome: cliente?.nome ?? nomeCliente ?? "",
            endereco,
            endereco_numero: numeroEndereco || "",
            complemento: complemento || "",
            bairro,
            cidade,
            estado,
            cep,
            celular: cliente?.celular || "",
            email: "",
            codigoPedido: "",
            valor: validacaoDesconto.totalLiquido.toFixed(2),
            tipo_pagamento: formaPagamento || "",
          });
        } catch (error) {
          enqueueSnackbar(
            error?.response?.data?.messages ||
              error?.response?.data?.mensagem ||
              "Falha ao enviar para Contas a Receber / Sankhya.",
            { variant: "error" }
          );
        }
      }

      await api.put(
        `/v2/agendaCare/agendamento/${location.state.row.id}`,
        dados
      );

      if (arquivosPrescricao.length > 0) {
        setLoadingPrescricoes(true);
        const formData = new FormData();
        arquivosPrescricao.forEach((arquivoPrescricao) => {
          formData.append("file", arquivoPrescricao);
        });

        await api.post(
          `/v2/agendaCare/agendamento/${location.state.row.id}/prescricoes`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      history.push("/agendaCare");
      enqueueSnackbar("Alterações salvas com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      const status = error?.response?.status;
      if (status === 413) {
        enqueueSnackbar(
          error?.response?.data?.messages ||
            "Limite excedido: até 10MB por arquivo e no máximo 20 arquivos por envio.",
          { variant: "warning" }
        );
        return;
      }
      if (status === 415) {
        enqueueSnackbar(error?.response?.data?.messages || "Formato inválido. Envie PDF, JPG ou PNG.", {
          variant: "warning",
        });
        return;
      }

      enqueueSnackbar(
        error?.response?.data?.messages || "Erro! Não foi possível alterar os dados do agendamento.",
        { variant: "error" }
      );
    } finally {
      setLoadingPrescricoes(false);
      setSalvando(false);
    }
  };

  const pegarDadosAgendamento = useCallback(async () => {
    setLoading(true);
    if (location.state?.row) {
      try {
        const {
          data: { data },
        } = await api.get(`v2/agendaCare/agendamento/${location.state.row.id}`);
        setProcedimentosVinculados(data.procedimentos || []);
        setItensIniciais(
          data.procedimentos.map((el) => ({
            procedimentoId: el.id,
            quantidade: el.agendamento_procedimento?.quantidade || 1,
          }))
        );
        setSituacao(data.situacao);
        setCliente(data.cliente);
        setEndereco(data.endereco);
        setCep(data.cep);
        setBairro(data.bairro);
        setCidade(data.cidade);
        setComplemento(data.complemento || data.cliente?.complemento || "");
        setObservacao(data.observacoes);
        setEstado(data.estado);
        setDesconto(data.desconto);
        setFormaPagamento(data.formaPagamento);
        setLocalAtendimento(data.localAtendimento);
        setMedicacaoOrigem(data.medicacaoOrigem);
        setPagamentoStatus(data.pagamentoStatus);

        setDataAgendamento(data.data);
        setHoraAgendamento(data.hora || "");
        setEnfermeiroId(data.enfermeiro?.id || "");
        setNumeroEndereco(data.enderecoNumero || "");

        idAgendamento.current = location.state.row.id;
        await carregarPrescricoes(location.state.row.id);

        setNomeCliente(data.cliente.nome);
        setCpfCliente(cpfSomenteDigitos(data.cliente.cpf));
      } catch (error) {
        enqueueSnackbar(error.response.data.messages, {
          variant: "error",
        });
      }
    } else {
      history.push("/agendaCare");
    }
    setLoading(false);
  }, [carregarPrescricoes, enqueueSnackbar, history, location.state?.row]);

  useEffect(() => {
    pegarDadosAgendamento();
  }, [pegarDadosAgendamento]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDescontoDebounced(desconto);
    }, 300);

    return () => clearTimeout(timer);
  }, [desconto]);

  const subtotalProcedimentos = calcularSubtotal(procedimentoSelecionado);
  const validacaoDescontoAtual = validarDesconto(descontoDebounced, subtotalProcedimentos);
  const totalExames = formatarTotalExibicao(procedimentoSelecionado, descontoDebounced);

  const dadosPdf = useMemo(
    () => ({
      cliente,
      observacaoCliente,
      enfermeiroId,
      data: dataAgendamento,
      hora: horaAgendamento,
      situacao,
      endereco,
      numeroEndereco,
      cep,
      bairro,
      cidade,
      estado,
      complemento,
      observacao,
      desconto: descontoDebounced,
      formaPagamento,
      localAtendimento,
      pagamentoStatus,
      procedimentoSelecionado,
    }),
    [
      cliente,
      observacaoCliente,
      enfermeiroId,
      dataAgendamento,
      horaAgendamento,
      situacao,
      endereco,
      numeroEndereco,
      cep,
      bairro,
      cidade,
      estado,
      complemento,
      observacao,
      descontoDebounced,
      formaPagamento,
      localAtendimento,
      pagamentoStatus,
      procedimentoSelecionado,
    ]
  );

  const obterPayloadPdf = useObterPayloadPdfOrcamento(dadosPdf);

  const handleDescontoChange = (event) => {
    const valor = event.target.value;
    if (valor === "") {
      setDesconto("");
      return;
    }
    if (!/^\d*(\.\d{0,2})?$/.test(valor)) {
      return;
    }
    setDesconto(valor);
  };

  return (
    <>
      <Header titulo="Editar Agendamento" />
      <Container maxWidth={false} sx={{ px: { xs: 3, md: 6, lg: 8 }, pt: 3, pb: 5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
            mb: 1,
          }}
        >
          <Button onClick={() => history.push({ pathname: "/agendaCare" })}>
            <ArrowBackIcon style={{ color: "#003399" }} />
          </Button>

          <BotaoPdfAgendamento
            label="Gerar orçamento (PDF)"
            obterPayload={obterPayloadPdf}
          />
        </Box>
        <Paper
          style={{
            padding: "48px 64px 40px",
            marginTop: "24px",
            width: "100%",
            boxSizing: "border-box",
          }}
          elevation={2}
        >
          <form
            onSubmit={handleSubmit}
            noValidate
            style={{ width: "100%" }}
          >
            <GridContainer
              spacing={2}
              sx={{ width: "100%", margin: 0, flexWrap: { xs: "wrap", md: "nowrap" } }}
              alignItems="flex-start"
            >
              <GridContainer item xs={12} md={6} spacing={2} sx={{ minWidth: 0 }}>
                <GridItem xs={3}>
                  <SelectSituacao
                    onChange={(e) => {
                      setSituacao(e.target.value);
                    }}
                    value={situacao}
                    todas={false}
                    required
                  />
                </GridItem>

                <GridItem xs={9}>
                  <AutoCompleteClientes
                    value={cliente}
                    onChange={setCliente}
                    required
                  />
                </GridItem>
                <GridItem xs={12}>
                  <ObservacoesClinicas
                    clienteId={cliente?.id}
                    onDescricaoChange={setObservacaoCliente}
                  />
                </GridItem>

                <GridItem xs={8}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setEndereco(e.target.value);
                    }}
                    value={endereco}
                    label="Endereço"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <SelectEstado
                    onChange={(e) => {
                      setEstado(e.target.value);
                    }}
                    value={estado}
                  />
                </GridItem>
                <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    size="small"
                    variant="text"
                    disabled={!temEnderecoMinimo({ endereco, cidade, cep })}
                    onClick={() =>
                      abrirNoMaps({
                        endereco,
                        numero: "",
                        bairro,
                        cidade,
                        estado,
                        cep,
                      })
                    }
                  >
                    Abrir no Maps
                  </Button>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCep(e.target.value);
                    }}
                    value={cep}
                    required
                    fullWidth
                    label="CEP"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setBairro(e.target.value);
                    }}
                    value={bairro}
                    required
                    fullWidth
                    label="Bairro"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCidade(e.target.value);
                    }}
                    value={cidade}
                    required
                    fullWidth
                    label="Cidade"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setComplemento(e.target.value);
                    }}
                    value={complemento}
                    fullWidth
                    label="Complemento"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Local"
                    value={localAtendimento}
                    onChange={(e) => setLocalAtendimento(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_LOCAL_ATENDIMENTO.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Medicação"
                    value={medicacaoOrigem}
                    onChange={(e) => setMedicacaoOrigem(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_MEDICACAO_ORIGEM.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Pagamento"
                    value={pagamentoStatus}
                    onChange={(e) => setPagamentoStatus(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_PAGAMENTO_STATUS.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={e => {
                      setObservacao(e.target.value);
                    }}
                    value={observacao}
                    multiline
                    maxRows={5}
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="standard"
                  />
                </GridItem>

              </GridContainer>

              <GridContainer item xs={12} md={6} spacing={2} sx={{ minWidth: 0 }}>
                <GridItem xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: 480,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <TabelaProcedimentosAgendamento
                      initialItems={itensIniciais}
                      procedimentosVinculados={procedimentosVinculados}
                      atualizaTabela={atualizaTabelaProcedimentos}
                      setSelectedRows={setProcedimentoSelecionado}
                    />
                    <GridContainer spacing={2} alignItems="flex-start">
                      <GridItem xs={12} sm={4}>
                        <SelectFormaPagamento
                          onChange={(e) => {
                            setFormaPagamento(e.target.value);
                          }}
                          value={formaPagamento}
                          required
                        />
                      </GridItem>
                      {checarPermissao("AGC002") && (
                        <>
                          <GridItem xs={12} sm={4}>
                            <Input
                              onChange={handleDescontoChange}
                              value={desconto}
                              fullWidth
                              label="Desconto R$"
                              type="number"
                              variant="standard"
                              inputProps={{ min: 0, step: 0.01 }}
                              error={!validacaoDescontoAtual.valido}
                              helperText={
                                !validacaoDescontoAtual.valido
                                  ? validacaoDescontoAtual.mensagem
                                  : ""
                              }
                            />
                          </GridItem>

                          <GridItem xs={12} sm={4}>
                            <Input
                              value={totalExames}
                              fullWidth
                              label="Total"
                              type="text"
                              inputProps={{ readOnly: true }}
                              variant="standard"
                            />
                          </GridItem>
                        </>
                      )}
                    </GridContainer>
                    <div>
                      <h4 style={{ margin: "8px 0" }}>Prescrições</h4>
                      <div
                        style={{
                          border: "1px dashed #B0BEC5",
                          borderRadius: "10px",
                          minHeight: "110px",
                          padding: "14px 16px",
                          backgroundColor: "#FAFAFA",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="file"
                          ref={inputPrescricoesRef}
                          multiple
                          accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                          style={{ display: "none" }}
                          onChange={handleSelecionarArquivosPrescricao}
                        />
                        <Button
                          type="button"
                          variant="outlined"
                          style={{ color: "#0D47A1", fontSize: "16px", fontWeight: 600 }}
                          onClick={(event) => {
                            event.preventDefault();
                            inputPrescricoesRef.current?.click();
                          }}
                        >
                          Selecionar prescrições
                        </Button>
                        <span
                          style={{
                            marginTop: "14px",
                            fontSize: "14px",
                            color: "#424242",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          PDF, JPG ou PNG - até 10MB por arquivo
                        </span>
                      </div>

                      <div style={{ marginTop: "12px" }}>
                        <PrescricoesAgendamento
                          prescricoes={arquivosPrescricao}
                          emptyText="Nenhum arquivo novo selecionado."
                          onPreview={previewPrescricao.abrirPreviewLocal}
                          onRemove={handleRemoverArquivoPrescricao}
                        />
                      </div>

                      <div style={{ marginTop: "8px" }}>
                        <span style={{ fontSize: "13px", color: "#616161" }}>
                          Os arquivos novos selecionados serão enviados ao clicar em Salvar.
                        </span>
                      </div>

                      <div style={{ marginTop: "16px" }}>
                        <h5 style={{ margin: "0 0 8px", fontSize: "14px", color: "#424242" }}>
                          Prescrições salvas
                        </h5>
                        <PrescricoesAgendamento
                          prescricoes={prescricoes}
                          loading={loadingPrescricoes}
                          emptyText="Nenhuma prescrição salva neste agendamento."
                          onPreview={handleVisualizarPrescricao}
                          onDownload={handleDownloadPrescricao}
                          onRemove={(prescricao) => handleExcluirPrescricao(prescricao.id)}
                        />
                      </div>
                    </div>
                  </Box>
                </GridItem>
              </GridContainer>

            </GridContainer>

            {openModalForm && (
              <ModalProcedimento
                open={openModalForm}
                onClose={() => {
                  setOpenModalForm(false);
                  atualizarTabelaProcedimentos();
                }}
              />
            )}

            <GridContainer
              item
              sx={{ marginTop: "30px" }}
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                  color="gray"
                  variant="outlined"
                  disabled={salvando}
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  id="agendarButton"
                  type="button"
                  color="blue"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={salvando}
                >
                  {salvando ? "Aguarde..." : "Salvar"}
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
      <ModalPreviewPrescricao
        open={previewPrescricao.open}
        loading={previewPrescricao.loading}
        arquivo={previewPrescricao.arquivoPreview}
        blobUrl={previewPrescricao.blobUrl}
        onClose={previewPrescricao.fecharPreview}
        onDownload={handleDownloadPreview}
      />
      {(loading || salvando) && <Loading />}
    </>
  );
}
